"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeDuplicateRequestDetector = void 0;
class FakeDuplicateRequestDetector {
    detect() { }
    clear() { }
}
exports.FakeDuplicateRequestDetector = FakeDuplicateRequestDetector;
